import { useNavigate } from 'react-router-dom'

import { UpsellingButton as F1UpsellButton } from '@factorialco/factorial-one-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface UpsellButtonProps {
  label?: string
  size: string
  onClick: () => Promise<void>
}

const UpsellButton = ({ label, size, onClick }: UpsellButtonProps) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <F1UpsellButton
      label={label ?? i18n.t('upselling_kit.button.request_information')}
      size={size}
      showConfirmation
      onRequest={onClick}
      errorMessage={{
        title: i18n.t('upselling_kit.upselling_button.error_message.title'),
        description: i18n.t('upselling_kit.upselling_button.error_message.description'),
      }}
      successMessage={{
        title: i18n.t('upselling_kit.upselling_button.success_message.title'),
        description: i18n.t('upselling_kit.upselling_button.success_message.description'),
        buttonLabel: i18n.t('upselling_kit.upselling_button.success_message.button_label'),
        buttonOnClick: () => {
          navigate(navigation.discover.marketplaceModules.fullPath())
        },
      }}
      loadingState={{
        label: i18n.t('upselling_kit.upselling_button.loading_state.label'),
      }}
      nextSteps={{
        title: i18n.t('upselling_kit.upselling_button.next_steps.title'),
        items: [
          {
            text: i18n.t('upselling_kit.upselling_button.next_steps.item_1'),
            isCompleted: true,
          },
          {
            text: i18n.t('upselling_kit.upselling_button.next_steps.item_2'),
            isCompleted: false,
          },
          {
            text: i18n.t('upselling_kit.upselling_button.next_steps.item_3'),
            isCompleted: false,
          },
        ],
      }}
      closeLabel={i18n.t('upselling_kit.upselling_button.close_label')}
    />
  )
}

export default UpsellButton
